import React, { useEffect, useState } from "react";
import { getAdminConsultationMode } from "../../utils/consultationMode";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useDebounce from "../../hooks/useDebounce";

// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
    FailedConsulatationApi,
    getUserHistoryApi,
    getUserListApi,
    logoutUserFromAllDevice,
    Missed_callAPi,
    Progress_callAPi,
    sendOtpAPi,
    waitlistApi,
    endWaitlistApi,
    //   verifyOtpApi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import ConsultationCustomerTabs from "../../components/PowerCustomer/ConsultationCustomerTabs";
import SectionLoaderOverlay from "../../components/loader/SectionLoaderOverlay";

// Utility function to calculate age from date of birth
const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return "---";
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    
    return age;
};

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;


// console.log('Gender', gender)

const ProgessConstulation = () => {
    let URL = process.env.REACT_APP_API_URL
    const [searchParam, setSearchParam] = useSearchParams()
    const [activePage, setActivePage] = useState(1);
    const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
    const [search, setSearch] = useState(
        getLocalStorage("userList", "search") || ""
    );
    const debounceValue = useDebounce(search || "", 300);
    const [total, setTotal] = useState(0);
    const [userList, setUserList] = useState([]);
    const [problemList, setProblemList] = useState([]);
    const [statusModal, setStatusModal] = useState(false);
    const [statusValue, setStatusValue] = useState("");
    const [statusId, setStatusId] = useState("");
    const [logoutUserModel, setLogoutUserModel] = useState(false);
    const [cancelCallModal, setCancelCallModal] = useState(false);
    const [selectedWaitlistId, setSelectedWaitlistId] = useState("");
    const [isListLoading, setIsListLoading] = useState(false);

    const [buttonref, buttonLoader] = useButtonLoader("Logout");
    const [cancelButtonref, cancelButtonLoader] = useButtonLoader("Cancel Call");

    const [WriteOtpModal, setwriteOtpModal] = useState(false);
    
    // Filter states
    const [genderValue, setGenderValue] = useState("");
    const [consultationModeValue, setConsultationModeValue] = useState("");
    const [consultationTypeValue, setConsultationTypeValue] = useState("");
    const [problemValue, setProblemValue] = useState("");
    const [consultantGenderValue, setConsultantGenderValue] = useState("");
    const [registrationDate, setRegistrationDate] = useState("");
    const [customerType, setCustomerType] = useState("all");
    


    // useEffect(() => {
    //     setLocalStorage("userList", "search", search);
    // }, [search]);
    console.log('search ===>', search)

    const handleLogoutHandler = async () => {
        try {
            buttonLoader(true);
            const sendData = { userId: statusId };
            const { data } = await logoutUserFromAllDevice(sendData);
            if (data.code === 200) {
                console.log("Date", data);
                logoutCloseModel();
            } else {
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            buttonLoader(false);
        }
    };

    // handle all hooks
    const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();


    const handleExcelDownload = () => {
        try {
            const url = `${URL}/admin/user/download`;
            const params = {};
            requestDownload(url, `user-excel-file-${dateFormat(new Date())}`, params);
        } catch (e) {
            console.log(e.message);
        }
    };
    //*********Handel status********* */
    const statusUpdateHandler = (id, status) => {
        setStatusModal(true);
        setStatusId(id);
        setStatusValue(status);
    };

    //*********Logout handler function********* */
    const userLogoutHandler = (id) => {
        setStatusId(id);
        setLogoutUserModel(true);
    };

    //*********Cancel call handler function********* */
    const cancelCallHandler = (waitlistId) => {
        setSelectedWaitlistId(waitlistId);
        setCancelCallModal(true);
    };

    //*********Handle cancel call API call********* */
    const handleCancelCall = async () => {
        try {
            cancelButtonLoader(true);
            const sendData = { waitlistId: selectedWaitlistId };
            const { data } = await endWaitlistApi(sendData);

            // Handle different success flags from API
            const isSuccess =
                data?.code === 200 ||
                data?.status === true ||
                data?.success === true;

            if (isSuccess) {
                console.log("Cancel call success", data);
                toastMessage(data?.message || "Call cancelled successfully", "success", "userList");

                // Optimistically remove cancelled call from current list using string comparison
                setUserList((prevList) =>
                    prevList.filter(
                        (item) =>
                            item?._id?.toString() !==
                            selectedWaitlistId?.toString()
                    )
                );

                // Also trigger a background refresh to keep data in sync
                getUserList(activePage);
            } else {
                toastMessage(data?.message || "Failed to cancel call", "error", "userList");
            }
        } catch (error) {
            console.log("Cancel call error", error);
            toastMessage("Failed to cancel call", "error", "userList");
        } finally {
            cancelButtonLoader(false);
            // Always close modal after API call completes so it doesn't get stuck open
            cancelCallCloseModal();
        }
    };

    // gender handler
    const genderHandler = (value) => {
        setGenderValue(value);
    };
    
    // Problem handler
    const problemValueHandler = (value) => {
        setProblemValue(value);
    };

    // Consultation mode handler
    const consultationModeHandler = (value) => {
        setConsultationModeValue(value);
    };

    // Consultation type handler
    const consultationTypeHandler = (value) => {
        setConsultationTypeValue(value);
    };

    // Consultant gender handler
    const consultantGenderHandler = (value) => {
        setConsultantGenderValue(value);
    };



    //*********Handel Pagination********* */
    const handlePageChange = (page) => {
        setActivePage(page);
    };
    //*********Handel refresh icon********* */
    const refreshHandler = (event) => {
        setSearch("");
        setActivePage(1);
        setGenderValue("");
        setConsultationModeValue("");
        setConsultationTypeValue("");
        setProblemValue("");
        setConsultantGenderValue("");
        setRegistrationDate("");
        getUserList(1);
    };
    //------------------usre-listing-Api----------------------------------
    const getUserList = async (page = 1) => {
        try {
            setIsListLoading(true);
            const sendData = {
                page: `${page}`,
                limit: "10",
                filter: {}
            };

            if (customerType !== "all") {
                sendData.filter.customerType = customerType;
            }

            if (search) {
                sendData.filter.search = search;
            }
            if (problemValue) {
                sendData.filter.problems = problemValue;
            }
            if (genderValue) {
                sendData.filter.gender = genderValue;
            }
            if (registrationDate) {
                sendData.filter.registerDate = registrationDate;
            }
            if (consultationModeValue) {
                sendData.filter.consultationMode = consultationModeValue;
            }
            if (consultationTypeValue) {
                sendData.filter.consultationType = consultationTypeValue;
            }
            if (consultantGenderValue) {
                sendData.filter.consultantGender = consultantGenderValue;
            }

            const { data } = await Progress_callAPi(sendData);
            if (data.code === 200) {
                console.log('data ===>', data.result.list)
                console.log("remainingCoins ===>");
                data.result.list.map((user, index) => {
                    console.log(`User ${index + 1}:`, user.remainingCoins);
                });
                setUserList(data?.result?.list || []);
                setTotal(data?.result?.total || 0);
                // scrollToUp();
            } else {
                setUserList([]);
                setTotal(0);
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsListLoading(false);
        }
    };

    const closeModel = () => {
        setStatusModal(false);
        setStatusValue("");
        setStatusId("");
    };

    const logoutCloseModel = () => {
        setLogoutUserModel(false);
        setStatusId("");
    };

    const cancelCallCloseModal = () => {
        setCancelCallModal(false);
        setSelectedWaitlistId("");
    };

    // problem list handler function

    const fetchProblemHandler = async () => {
        try {
            const { data } = await fatchCategoryApi();
            if (data.code === 200) {
                setProblemList(data?.result?.categoryList || []);
            } else {
                setProblemList([]);
                toastMessage(data.message, "error", "categoryList");
            }
        } catch (error) {
            console.log("error", error);
        }
    };



    const handleRegistrationDate = (date) => {
        const utcDateString = dateFormatUtc(date);
        setRegistrationDate(utcDateString);
    };

    // Apply filter function
    const applyFilter = () => {
        setActivePage(1); // Reset to page 1 when applying filters
        getUserList(1);
    };

    // useEffect(() => {
    //   if (debounceValue) {
    //     searchParam.set('query', debounceValue)
    //   } else {
    //     searchParam.delete('query')
    //   }
    //   if (activePage === 1) {
    //     searchParam.delete('page')
    //   }
    //   setSearchParam(searchParam)
    //   getOrder(activePage, debounceValue)
    // }, [searchParam, debounceValue])

    // useEffect(() => {
    //     if (Number(activePage) === 1) {
    //         searchParam.delete("page");
    //     }
    //     if (!genderValue) {
    //         searchParam.delete("gender");
    //     }
    //     if (!problemValue) {
    //         searchParam.delete("problem");
    //     }
    //     if (!consultationModeValue) {
    //         searchParam.delete("consultationMode");
    //     }
    //     if (!consultationTypeValue) {
    //         searchParam.delete("consultationType");
    //     }
    //     if (!consultantGenderValue) {
    //         searchParam.delete("consultantGender");
    //     }
    //     setSearchParam(searchParam);
    //     getUserList(debounceValue);
    // }, [searchParam, debounceValue]);

    useEffect(() => {
        getUserList(activePage);
    }, [activePage, customerType]);

    useEffect(() => {
        fetchProblemHandler();
    }, []);
    return (
        <>
            <OTPModalCNF verifiedHandle={() => {
                console.log('OTP Verified Successfully!')
            }} />
            <div className="WrapperArea">
                <div className="WrapperBox">
                    <div className="TitleBox">
                        {/* <div className="user_management_heading"> */}
                        <h4 className="Title">Progress Call/Chat</h4>
                        <div className="block_user_button">
                            {/* <span
                className="user_management_excel"
                onClick={handleExcelDownload}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div className="csv-image-wrapper">
                    <figure>
                      <img src={csv} alt="csv file download" />
                    </figure>
                  </div>
                )}
              </span> */}
                            {/* <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    // onClick={() => setAddConsultantModel(true)}
                    >
                      {/* <AddIcon /> */}
                            {/* Deleted User
                    </button>
                  </div>
                </Link>
              </div>  */}
                        </div>
                        {/* </div> */}
                    </div>
                    <ConsultationCustomerTabs includeAll allLabel="All Progress" value={customerType} onChange={(value) => {
                        setCustomerType(value);
                        setActivePage(1);
                    }} />
                    <div className="FilterBox FilterArea">
                            {/* Row 1: Search Bar and Basic Filters */}
                            <div className="group_filter_value" style={{ 
                                marginBottom: '15px', 
                                display: 'flex !important', 
                                flexWrap: 'wrap !important', 
                                gap: '15px', 
                                alignItems: 'center',
                                width: '100%',
                                flexDirection: 'row'
                            }}>
                                {/* Search Bar */}
                                <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
                                    <input
                                        type="search"
                                        className={`form-control ${search && "active"}`}
                                        placeholder="Search"
                                        value={search || ""}
                                        style={{ "--color": "#FF8989" }}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                {/* User Gender Filter */}
                                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                    <Select
                                        className={`form-control ${genderValue && "active"}`}
                                        value={genderValue}
                                        onChange={(e) => genderHandler(e.target.value)}
                                    >
                                        <option value="">User Gender</option>
                                        {gender &&
                                            gender.length > 0 &&
                                            gender.map((genderItem, index) => {
                                                return (
                                                    <option value={genderItem.value} key={index}>
                                                        {genderItem.name}
                                                    </option>
                                                );
                                            })}
                                    </Select>
                                </div>

                                {/* Mode of Consultation Filter */}
                                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                    <Select
                                        className={`form-control ${consultationModeValue && "active"}`}
                                        value={consultationModeValue}
                                        onChange={(e) => consultationModeHandler(e.target.value)}
                                    >
                                        <option value="">Mode of Consultation</option>
                                        <option value="chat">Chat</option>
                                        <option value="call">Call</option>
                                    </Select>
                                </div>

                                {/* Type of Consultation Filter */}
                                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                    <Select
                                        className={`form-control ${consultationTypeValue && "active"}`}
                                        value={consultationTypeValue}
                                        onChange={(e) => consultationTypeHandler(e.target.value)}
                                    >
                                        <option value="">Type of Consultation</option>
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </Select>
                                </div>

                                {/* Refresh Button */}
                             

                           
                                {/* Problem Filter */}
                                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                    <Select
                                        className={`form-control ${problemValue && "active"}`}
                                        value={problemValue}
                                        onChange={(e) => problemValueHandler(e.target.value)}
                                    >
                                        <option value="">Problem</option>
                                        {problemList &&
                                            problemList.length > 0 &&
                                            problemList.map((problem, index) => {
                                                return (
                                                    <option value={problem._id} key={index}>
                                                        {problem.title}
                                                    </option>
                                                );
                                            })}
                                    </Select>
                                </div>

                                {/* Consultant Gender Filter */}
                                <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                    <Select
                                        className={`form-control ${consultantGenderValue && "active"}`}
                                        value={consultantGenderValue}
                                        onChange={(e) => consultantGenderHandler(e.target.value)}
                                    >
                                        <option value="">Consultant Gender</option>
                                        {gender &&
                                            gender.length > 0 &&
                                            gender.map((genderItem, index) => {
                                                return (
                                                    <option value={genderItem.value} key={index}>
                                                        {genderItem.name}
                                                    </option>
                                                );
                                            })}
                                    </Select>
                                </div>


                                        <SecondaryButton 
                                            onClick={applyFilter}
                                            style={{ padding: '8px 16px', fontSize: '14px' }}
                                        >
                                            Apply
                                        </SecondaryButton>
                                    <SecondaryButton onClick={refreshHandler}>
                                      Clear
                                    </SecondaryButton>
                            </div>
                        </div>
                    <div className="content-table" style={{ position: "relative", minHeight: 200 }}>
                        {isListLoading && <SectionLoaderOverlay />}
                        <table>
                            <thead>
                                <tr>
                                    <th>S. No.</th>
                                    <th>Consultation Connecting Time</th>
                                    <th>Consultation Start Time</th>
                                    <th>User ID</th>
                                    <th>User Name</th>
                                    <th>User Contact Number</th>
                                    <th>Gender</th>
                                    <th>Mode of Consultation</th>
                                    <th>Type of Consultation</th>
                                    <th>Problem</th>
                                    <th>Consultant Name</th>
                                    <th>Consultant Contact Number</th>
                                    <th>Consultant Gender</th>
                                    <th>Time Duration</th>
                                    <th>Customer Type</th>
                                    <th>Power Origin</th>
                                    <th>Power Customer Since</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userList.length > 0 ? (
                                    userList.map((user, index) => {
                                        console.log("user ===>", user)
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <td>{findSerialNumber(index, activePage, 10)}</td>
                                                    <td>
                                                        {
                                                            user.logs?.find(log => log.callBy === "user")
                                                                ? dateFormat(new Date(user.logs.find(log => log.callBy === "user").timestamp))
                                                                : dateFormat(user.createdAt) || "---"
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            user.timeLap?.startTime ?
                                                                dateFormat(new Date(user.timeLap.startTime))
                                                                : "---"
                                                        }
                                                    </td>
                                                    <td>{user?.userDetails?.userId || "---"}</td>
                                                    <td>{user?.request_form?.firstName || "---"}</td>
                                                    <td>{user?.userDetails?.mobile || "---"}</td>
                                                    <td>
                                                        {user.request_form?.gender
                                                            ? CapitalizeFirstWord(user.request_form?.gender)
                                                            : "---"}
                                                    </td>
                                                    <td>{getAdminConsultationMode(user)}</td>
                                                    <td>{user?.coupon?.code === "FREE5MINUTES" ? "Free" : "Paid"}</td>
                                                    <td>{user?.request_form?.problem || "---"}</td>
                                                    <td>{user?.consultantDetails?.accountName || "---"}</td>
                                                    <td>{user?.consultantDetails?.mobile || "---"}</td>
                                                    <td>
                                                        {user?.consultantDetails?.gender
                                                            ? CapitalizeFirstWord(user?.consultantDetails?.gender)
                                                            : "---"}
                                                    </td>
                                                    <td>{user?.session_info?.duration || "---"}</td>
                                                    <td>{user?.customerType || "---"}</td>
                                                    <td>{user?.powerOrigin || "---"}</td>
                                                    <td>{user?.powerCustomerSince ? dateFormat(user.powerCustomerSince) : "---"}</td>
                                                    <td>
                                                        <div className="action_button">
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => cancelCallHandler(user._id)}
                                                                style={{ padding: '4px 8px', fontSize: '12px' }}
                                                            >
                                                                Cancel Call
                                                            </button>
                                                        </div>
                                                    </td>

                                                    {/* <td>
                            <div className="action_button">
                              <Link to={`${USER_DETAIL}/${user._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>

                              <Switch
                                checked={user.status}
                                onChange={() =>
                                  statusUpdateHandler(user._id, user.status)
                                }
                              />
                            </div>
                          </td> */}
                                                    {/* <td>
                            <div className="block_user_button">
                              <button
                                className="mx-4"
                                onClick={() => userLogoutHandler(user._id)}
                              // ref={buttonref}
                              >
                                Logout
                              </button>
                            </div>
                          </td> */}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <NotFound
                                        cols={18}
                                        msg="User not found!"
                                        icon={NOT_FOUND}
                                        loader={null}
                                    />
                                )}
                            </tbody>
                        </table>
                    </div>
                    {total > 10 ? (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            {statusModal && (
                <UserStatus
                    show={statusModal}
                    close={closeModel}
                    setListing={setUserList}
                    setUserDetail={""}
                    status={statusValue}
                    id={statusId}
                />
            )}

            {logoutUserModel && (
                <ModalBox
                    status={logoutUserModel}
                    onClose={logoutCloseModel}
                    title="Logout User from all Device"
                    description="Do you want to logout the user from all the devices?"
                    action={handleLogoutHandler}
                    ref={buttonref}
                />
            )}

            {cancelCallModal && (
                <ModalBox
                    status={cancelCallModal}
                    onClose={cancelCallCloseModal}
                    title="Cancel Call"
                    description="This button should only be used when a call gets stuck."
                    action={handleCancelCall}
                    ref={cancelButtonref}
                />
            )}

            <DownloadPasswordModal />
        </>
    );
};

export default ProgessConstulation;
